/**
 * Família tipográfica do app. O `body` (GlobalStyles) e o tema MUI já a aplicam
 * e os elementos herdam; declare-a só onde não há herança do DOM, como textos
 * desenhados em canvas (ECharts, amCharts) ou HTML de tooltip que a biblioteca
 * de gráfico estiliza com a própria fonte.
 */
export const FONT_FAMILY = 'Onest, sans-serif';
